import React from 'react';

const ProductPerformance: React.FC = () => {
  return <div>ProductPerformance</div>;
};

export default ProductPerformance;
